import { render, staticRenderFns } from "./PillsImagePage.vue?vue&type=template&id=1b678f7e&"
import script from "./PillsImagePage.vue?vue&type=script&lang=js&"
export * from "./PillsImagePage.vue?vue&type=script&lang=js&"
import style0 from "./PillsImagePage.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports